module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex justify-between py-6 border-b border-coolGray-200"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [(_vm.code === 'google-classroom') ? _c('img', {
    staticClass: "w-10 h-10 rounded-full",
    attrs: {
      "src": _vm.icon
    }
  }) : _c('img', {
    staticClass: "w-10 h-10 rounded-full",
    attrs: {
      "src": ("/static/integrations/" + _vm.title + ".png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-semibold ml-4 center items-center"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('pl-spinner') : [(!_vm.integration_connected) ? _c('button', {
    staticClass: "px-10 py-2 w-40 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.selectIntegration
    }
  }, [_vm._v("\n          Connect\n        ")]) : _c('div', [_c('span', {
    staticClass: "text-xs mx-20"
  }, [_vm._v(_vm._s(_vm.profile.email))]), _vm._v(" "), _c('button', {
    staticClass: "px-10 py-2 w-40 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading_to_disconnect
    },
    on: {
      "click": function($event) {
        return _vm.disconnectAccount()
      }
    }
  }, [_vm._v("\n            Disconnect\n          ")])])]], 2)]), _vm._v(" "), (_vm.show_integrations_premium_feature_modal) ? _c('integrations-premium-feature-modal', {
    on: {
      "close": function($event) {
        _vm.show_integrations_premium_feature_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_integrations_upgrade_modal) ? _c('integrations-upgrade-modal', {
    attrs: {
      "integration_name": _vm.integration.name,
      "integration_id": _vm.integration.id
    },
    on: {
      "close": function($event) {
        _vm.show_integrations_upgrade_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_classroom_modal) ? _c('disconnect-google-classroom-modal', {
    on: {
      "close": function($event) {
        _vm.show_disconnect_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_integration_modal) ? _c('profile-disconnect-integration-modal', {
    attrs: {
      "integration": _vm.integration || _vm.classroom_integration
    },
    on: {
      "close": function($event) {
        _vm.show_disconnect_integration_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_select_school) ? _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "size": 'md',
      "title": 'Select School'
    },
    on: {
      "close": function($event) {
        _vm.show_select_school = false
      }
    }
  }, [_c('div', {
    staticClass: "px-7"
  }, [_c('div', {
    staticClass: "my-7"
  }, [_vm._v("\n        You are a student in multiple schools in Parlay. Select the school\n        where you also have the " + _vm._s(_vm.integration.name) + " account that you are\n        trying to connect\n      ")]), _vm._v(" "), _vm._l((_vm.integration_schools), function(school) {
    return _c('div', {
      key: school.id,
      staticClass: "hover:underline hover:text-primary cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.selectSchool(school)
        }
      }
    }, [_vm._v("\n        " + _vm._s(school.name) + "\n      ")])
  })], 2)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e05434f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/profileIntegrationCard.vue
// module id = 1632
// module chunks = 61